import api from "./api";

export interface Notificacao {
  id: string;
  titulo: string;
  mensagem: string;
  lida: boolean;
  tipo: string;
  referenciaId: string | null;
  criadoEm: string;
}

export async function listarNotificacoes() {
  const response = await api.get("/notificacoes");
  return response.data.data as Notificacao[];
}

export async function contarNaoLidas() {
  const response = await api.get("/notificacoes/nao-lidas");
  return response.data.data.count as number;
}

export async function marcarComoLida(id: string) {
  await api.patch(`/notificacoes/${id}/lida`);
}

export async function marcarTodasComoLidas() {
  await api.patch("/notificacoes/ler-todas");
}
